

























import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class Achievements extends Vue {
  private links = [
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fachievements%2Flinen.jpg?alt=media&token=c2fa0ac9-6a68-430b-8c02-eb0564820a55',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fachievements%2Fbook.jpg?alt=media&token=d88fbff3-0f2d-4169-a46a-ece13c32a78b',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fachievements%2Faim.jpg?alt=media&token=7af96f77-6620-4e8c-9991-fc7823c8cb6c',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fachievements%2Fbiw.jpg?alt=media&token=27983805-a029-4b43-b92f-b2e766c37f5e',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fachievements%2Fpreme.jpg?alt=media&token=ed0bbce0-ceea-4ec4-b697-41f96c0cfb41',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fachievements%2Fmook.jpg?alt=media&token=7a6a9b66-08e9-4c17-8ad5-2f1b1705c05d',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fachievements%2Fnoon.jpg?alt=media&token=628a8218-e31d-4105-8c56-ab4d0848aafc',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fachievements%2Friew.jpg?alt=media&token=8bd32000-6e9f-48be-9213-2bb8c4aa18d8',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fachievements%2Fsroi.jpg?alt=media&token=938f190e-72e0-4c98-a7b4-c024582a6056',
  ];
}
